// language=GraphQL
export const ALL_FAQS_QUERY = `query Query {
  faqs: travelFaqs {
    id
    question
    answer
  }
}`

// language=GraphQL
export const SINGLE_FAQ_QUERY = `query Query($id: ID!) {
  faq: travelFaq(id: $id) {
    id
    question
    answer
  }
}`

// language=GraphQL
export const CREATE_FAQ_MUTATION = `
  mutation Mutation($input: CreateTravelFaqInput) {
    faq: createTravelFaq(input: $input) {
      id
      question
      answer
    }
  }`

// language=GraphQL
export const UPDATE_FAQ_MUTATION = `
  mutation Mutation($input: UpdateTravelFaqInput) {
    faq: updateTravelFaq(input: $input) {
      id
      question
      answer
    }
  }`

// language=GraphQL
export const DELETE_FAQ_MUTATION = `
  mutation Mutation($input: DeleteTravelFaqInput) {
    deleteTravelFaq(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_FAQ_MUTATION = `
  mutation Mutation($input: DeleteTravelFaqInput) {
    forceDeleteTravelFaq(input: $input) {
      success
    }
  }`
// language=GraphQL
export const FAQS_DEPENDENTS_QUERY = `query Query($id: ID!, $withTravels: Boolean = false) {
  groupedDependents: travelFaqDependents(id: $id) {
    travels @include(if: $withTravels) {
      id
      name
      isBestseller
      startDate
      endDate
      executionStatus
      title
      description
      introVideoUrl
      includedServices
      excludedServices
      pricingTable
      priceCalculationInfo
      programType
      programText
      minPrice
      minPriceManualOverride
      currency
    }
  }
}`
